import React from 'react';

import { CircularProgress } from '@material-ui/core';
import DOMPurify from 'dompurify';

import { renderMarkupWithMath } from 'utils/latexRenderer';

import Typography from 'components/Typography';

import styles from './styles.module.scss';

const AssignmentChatbotQuery = ({
  message = '',
  options = [],
  showOptions = false,
  isLoading,
  onOptionSelect = () => {}
}) => {
  if (message.length === 0 && options.length === 0) return;
  return (
    <div className={styles.messageContainer}>
      {!showOptions ? (
        <div className={styles.textBubble}>
          <Typography
            variant="B-Text-3"
            className={styles.queryContainer}
            component="div"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                renderMarkupWithMath({ text: message })
              )
            }}
          />
        </div>
      ) : (
        <div className={styles.optionsBubble}>
          <Typography variant="B-Text-3" className={styles.optionsHeader}>
            Choose your next question
          </Typography>

          <div className={styles.optionsList}>
            {isLoading ? (
              <div className={styles.loading}>
                <CircularProgress size={18} />
              </div>
            ) : (
              <>
                {options.map((option) => (
                  <button
                    key={option}
                    className={styles.optionButton}
                    onClick={() => onOptionSelect({ option })}
                    disabled={isLoading}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          renderMarkupWithMath({ text: option })
                        )
                      }}
                    />
                  </button>
                ))}
                <button key="survey-link" className={styles.optionButton}>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSczKswH9ErBEraogLRDYedkslOk3f6VGlELrcUPAH9kD2dlbw/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Rate this chat ⭐
                  </a>
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AssignmentChatbotQuery;
